import { Skeleton } from '@linka/ui/skeleton';
import * as Sentry from '@sentry/react';
import { Suspense, useEffect } from 'react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { RequireAuth } from './require-auth-wrapper';
import routesPrivate from './routes.private';
import routesPublic from './routes.public';

Sentry.init({
  dsn: 'https://4e001897061a75c52d37a2a135cbc482@o4509095395131392.ingest.us.sentry.io/4510462219714560',
  enabled: process.env.NODE_ENV === 'production',

  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  // Tracing
  tracesSampleRate: 0.5, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost'],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
});

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  ...routesPublic,
  {
    element: (
      <Suspense fallback={<Skeleton className='h-screen' />}>
        <RequireAuth />
      </Suspense>
    ),
    children: routesPrivate,
  },
]);

// limpeza dos loaders pendentes
if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}

export default router;
